import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { reset, submit } from 'redux-form';

import { Button, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import UpStickLogo from '../../components/UpStickLogo';
import LoginForm from './LoginForm';
import { login } from '../../actions/app';
import { graff } from '../../graff';
import {getCurrentUser} from '../../reducers/app';

const useStyles = makeStyles({
	root: {
		width: 380,
		maxWidth: '100%',
		padding: '36px 36px 28px',
		borderRadius: graff.radius.lg,
		boxShadow: graff.shadow.lg,
		backgroundColor: graff.color.surface
	},
	header: {
		composes: 'flexColumn center',
		marginBottom: 28
	},
	subtitle: {
		marginTop: 10,
		fontSize: 11,
		fontWeight: 600,
		letterSpacing: '.08em',
		textTransform: 'uppercase',
		color: graff.color.subtle
	},
	actions: {
		display: 'flex',
		justifyContent: 'flex-end',
		alignItems: 'center',
		gap: 10,
		marginTop: 12
	}
});

const Login = (props) => {
	// styles
	const classes = useStyles(props);

	// dispatch
	const dispatch = useDispatch();

	// selectors
	const user = useSelector(getCurrentUser);

	if (user) {
		return null;
	}

	const _submit = () => dispatch(submit('login'));
	const _reset = () => dispatch(reset('login'));

	const _login = values => {
		dispatch(login(values.username, values.password));
		_reset();
	};

	return (
		<Paper className={classes.root} elevation={0}>
			<div className={classes.header}>
				<UpStickLogo />
				<div className={classes.subtitle}>Back-office</div>
			</div>
			<LoginForm onSubmit={_login} />
			<div className={classes.actions}>
				<Button onClick={_reset}>Annuler</Button>
				<Button variant='contained' color='primary' onClick={_submit}>Se connecter</Button>
			</div>
		</Paper>
	)
};

export default Login;
